<template>
	<div
		class="h-6 w-6 rounded-full bg-purple-500 text-white text-sm flex items-center justify-center"
		:style="`background: ${userColor.bg}; color: ${userColor.text}`"
	>
		{{
			user?.fullName
				?.split(" ")
				.map((n) => n[0])
				.join("")
		}}
	</div>
</template>

<script lang="ts" setup>
import { computedAsync } from "@vueuse/core";
import {
	getTextColorFromBackground,
	stringToRgb,
} from "../../helpers/uiHelpers";
import { queries } from "@loanlink-nl/zero";
import { useQuery } from "@/composables/useZero";
import { useUserStore } from "@/store/useUserStore";

const props = defineProps<{
	userId: string;
}>();

const { data: user } = useQuery(() => queries.user.byId(props.userId));

const userStore = useUserStore();

const userColor = computedAsync(
	async () => {
		let color = userStore.colors[props.userId];
		if (color) {
			return color;
		}

		const rgb = await stringToRgb(props.userId);
		color = {
			bg: rgbToCss(rgb),
			text: rgbToCss(getTextColorFromBackground(...rgb)),
		};
		userStore.colors[props.userId] = color;

		return color;
	},
	{
		bg: "rgb(0, 0, 0)",
		text: "rgb(255, 255, 255)",
	},
);

function rgbToCss(rgb: [number, number, number]) {
	return `rgb(${rgb.join(", ")})`;
}
</script>
